<template>
  <transition mode="out-in" v-on:enter="enterPage" v-on:leave="leavePage" v-bind:css="false">
    <slot></slot>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import { Power1, TimelineMax } from "gsap";

export default {
  name: 'TransitionWrapper',
  data() {
    return {
      to: '',
      from: ''
    };
  },
  computed: {
    ...mapState(['userAgent', 'currentPage'])
  },
  methods: {
    enterPage(el, done) {
      this.$nextTick(() => {
        if (this.from.name === "Home" && (this.to.name === "Susan" || this.to.name === "Joseph" || this.to.name === "Gabrielle")) {
          this.enter_patients_from_home(el, done);
          return true;
        }
        // from patient to patient
        if (this.from.name === "Susan" && (this.to.name === "Joseph" || this.to.name === "Gabrielle")) {
          this.from_patient_to_patient(el, done);
          return true;
        }
        if (this.from.name === "Joseph" && (this.to.name === "Susan" || this.to.name === "Gabrielle")) {
          this.from_patient_to_patient(el, done);
          return true;
        }
        if (this.from.name === "Gabrielle" && (this.to.name === "Susan" || this.to.name === "Joseph")) {
          this.from_patient_to_patient(el, done);
          return true;
        }
        done();
      });
    },
    leavePage(el, done) {
      this.$nextTick(() => {
        if (this.to.name === "Home" && (this.from.name === "Susan" || this.from.name === "Joseph" || this.from.name === "Gabrielle")) {
          this.leave_patient_to_home(el, done);
          return true;
        }
        if (this.from.name === "Home" && (this.to.name === "Susan" || this.to.name === "Joseph" || this.to.name === "Gabrielle")) {
          document.querySelector('.site__wrapper').style.overflow = 'hidden';
          document.querySelector('.site__wrapper').classList.add('height-auto');
          let toName = this.to.name.toLowerCase();
          this.leave_home_to_patients(el, done, toName);
          return true;
        }
        if (this.from.name === "Susan" && (this.to.name === "Joseph" || this.to.name === "Gabrielle")) {
          this.leave_patient_to_patient(el, done);
          return true;
        }
        if (this.from.name === "Joseph" && (this.to.name === "Susan" || this.to.name === "Gabrielle")) {
          this.leave_patient_to_patient(el, done);
          return true;
        }
        if (this.from.name === "Gabrielle" && (this.to.name === "Susan" || this.to.name === "Joseph")) {
          this.leave_patient_to_patient(el, done);
          return true;
        }
        done();
      });
    },
    enter_patients_from_home(el, done) {
      if (this.$route.query.screentest) return true;
      let tl = new TimelineMax({ onComplete: done });
      if (this.userAgent.window.width > 1024 || (this.userAgent.window.width >= 1024 && this.userAgent.orientation === 'landscape')) {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.sideNav', 1.5, { opacity: 0 }, { opacity: 1 }, 0);
        tl.fromTo('.section_wrapper', 1.5, { opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 0);
        tl.fromTo('.sidebar_patient', 1.5, { opacity: 0 }, { opacity: 1 }, 0);
        tl.fromTo('.progress_bar', 1.5, { opacity: 0 }, { opacity: 1 }, 0);
        tl.set(['.sideNav', '.section_wrapper', '.sidebar_patient', '.progress_bar', document.documentElement], { clearProps: 'all' });
      } else {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.navigation', 1, { opacity: 0, x: -100 }, { opacity: 1, x: 0 }, 0);
        tl.fromTo('.section-head', 1, { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0);
        tl.fromTo('.section_wrapper', 1, { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0);
        tl.set(['.section_wrapper', '.section-head', '.navigation', document.documentElement], { clearProps: 'all' });
      }
    },
    leave_patient_to_home(el, done) {
      if (this.$route.query.screentest) return true;
      let tl = new TimelineMax({ onComplete: done });
      if (this.userAgent.window.width > 1024 || (this.userAgent.window.width >= 1024 && this.userAgent.orientation === 'landscape')) {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.sidebar_patient', 0.5, { opacity: 1 }, { opacity: 0 }, 0);
        tl.fromTo('.section_wrapper', 1.2, { opacity: 1, y: 0 }, { opacity: 0, y: 50 }, 0);
        tl.fromTo('.progress_bar', 1.2, { opacity: 1 }, { opacity: 0 }, 0);
        tl.set(['section_wrapper', '.progress_bar', '.sidebar_patient', document.documentElement], { clearProps: 'all' });
      } else {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.section-head', 1, { opacity: 1, y: 0 }, { opacity: 0, y: 50 }, 0);
        tl.fromTo('.section_wrapper', 1, { opacity: 1, y: 0 }, { opacity: 0, y: 50 }, 0);
        tl.set(['.section_wrapper', '.section-head', document.documentElement], { clearProps: 'all' });
      }
    },
    leave_home_to_patients(el, done, slug) {
      if (this.$route.query.screentest) return true;
      let susanItem = document.querySelector('.patient_item-susan');
      let josephItem = document.querySelector('.patient_item-joseph');
      let gabrielleItem = document.querySelector('.patient_item-gabrielle');
      let tl = new TimelineMax({ onComplete: done });
      if (this.userAgent.window.width > 1024) {
        tl
        .to('.patient_item-' + slug, 0.5, { attr: { height: '100%', width: '100%' }, ease: Power1.easeInOut })
        .to('.patient_name', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.patient_description', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.patient_button', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.patient_health', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.homepage-head', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.sideNav', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.divider-1', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.divider-2', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1')
        .to('.home_wrapper', 0.5, { background: 'none', ease: Power1.easeInOut }, '-=1')
        .to('.patient_footnotes', 0.5, { opacity: 0, ease: Power1.easeInOut }, '-=1');
        if (slug === 'susan') {
          tl
          .to(susanItem, 1, { left: '0%', width: '25%', opacity: 0, ease: Power1.easeInOut }, 0.5)
          .to(josephItem, 1, { x: '200%', autoAlpha: 0, ease: Power1.easeInOut }, '-=1')
          .to(gabrielleItem, 1, { x: '200%', autoAlpha: 0, ease: Power1.easeInOut }, '-=1');
        } else if (slug === 'joseph') {
          tl
          .to(susanItem, 1, { x: '-200%' }, 0.5)
          .to(josephItem, 1, { left: '0%', width: '25%', opacity: 0 }, '-=1')
          .to(gabrielleItem, 1, { x: '200%', ease: Power1.easeInOut }, '-=1');
        } else {
          tl
          .to(susanItem, 1, { x: '-200%', autoAlpha: 0, ease: Power1.easeInOut }, 0.5)
          .to(josephItem, 1, { x: '-200%', autoAlpha: 0, ease: Power1.easeInOut }, '-=1')
          .to(gabrielleItem, 1, { left: '0%', width: '25%', opacity: 0, ease: Power1.easeInOut }, '-=1');
        }
      } else {
        tl
        .set(document.documentElement, { pointerEvents: 'none' }, 0)
        .set('.navigation', { opacity: 0 }, 0)
        .fromTo('.home_wrapper', 1, { opacity: 1 }, { opacity: 0 }, 0)
        // .fromTo('.logo-app', 1, { opacity: 1 }, { opacity: 0 }, 0)
        .fromTo('.divider-1', 1, { opacity: 1 }, { opacity: 0 }, 0)
        .set(['.logo-app', '.home_wrapper', document.documentElement], { clearProps: 'all' });
      }
    },
    // patient to patient
    from_patient_to_patient(el, done) {
      if (this.$route.query.screentest) return true;
      let tl = new TimelineMax({ onComplete: done });
      if (this.userAgent.window.width > 1024 || (this.userAgent.window.width >= 1024 && this.userAgent.orientation === 'landscape')) {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.sideNav', 1.5, { opacity: 0 }, { opacity: 1 }, 0);
        tl.fromTo('.section_wrapper', 1.5, { opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 0);
        tl.fromTo('.sidebar_patient', 1.5, { opacity: 0 }, { opacity: 1 }, 0);
        tl.fromTo('.progress_bar', 1.5, { opacity: 0 }, { opacity: 1 }, 0);
        tl.set(['.sideNav', '.section_wrapper', '.sidebar_patient', '.progress_bar', document.documentElement], { clearProps: 'all' });
      } else {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.navigation', 1, { opacity: 0, x: -100 }, { opacity: 1, x: 0 }, 0);
        tl.fromTo('.section-head', 1, { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0);
        tl.fromTo('.section_wrapper', 1, { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0);
        tl.set(['.section_wrapper', '.section-head', '.navigation', document.documentElement], { clearProps: 'all' });
      }
    },
    leave_patient_to_patient(el, done) {
      if (this.$route.query.screentest) return true;
      let tl = new TimelineMax({ onComplete: done });
      if (this.userAgent.window.width > 1024 || (this.userAgent.window.width >= 1024 && this.userAgent.orientation === 'landscape')) {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.sideNav', 0.25, { opacity: 1 }, { opacity: 0 }, 0);
        tl.fromTo('.section_wrapper', 1.2, { opacity: 1, y: 0 }, { opacity: 0, y: 50 }, 0);
        tl.fromTo('.sidebar_patient', 0.5, { opacity: 1 }, { opacity: 0 }, 0);
        tl.fromTo('.progress_bar', 1.2, { opacity: 1 }, { opacity: 0 }, 0);
        tl.set(['.sideNav', '.section_wrapper', '.sidebar_patient', '.progress_bar', document.documentElement], { clearProps: 'all' });
      } else {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        tl.fromTo('.navigation', 1, { opacity: 1, x: 0 }, { opacity: 0, x: -100 }, 0);
        tl.fromTo('.section-head', 1, { opacity: 1, y: 0 }, { opacity: 0, y: 70 }, 0);
        tl.fromTo('.section_wrapper', 1, { opacity: 1, y: 0 }, { opacity: 0, y: 70 }, 0);
        tl.set(['.section_wrapper', '.section-head', '.navigation', document.documentElement], { clearProps: 'all' });
      }
    },
  },
  mounted() {
    if (this.$route.meta.id === 1 || this.$route.meta.id === 2 || this.$route.meta.id === 3) {
      this.enter_patients_from_home();
    }
  },
  watch: {
    $route(to, from) {
      this.to = to;
      this.from = from;
    }
  }
};

</script>

<style lang="scss" scoped></style>
